// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".atom-specs-list{align-items:center;background:#f5f5f5;border-radius:2rem;color:#181b34;display:flex;font-size:.875rem;justify-content:center;line-height:1.6;overflow:hidden;padding:.5rem 1rem;position:relative;transition:all .5s}@media only screen and (max-width:767px){.atom-specs-list{padding:.3rem .8rem .3rem .5rem}}.atom-specs-list .icon{display:inline-block;font-size:1.2rem;margin-right:.5rem;margin-top:-.1rem;vertical-align:middle}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
